import {BrickSnake2000Symbol} from "./BrickSnake2000Symbol";
import {SymbolArgs} from "./BrickSnake2000Symbol"
import {gsap} from "gsap"

export class PaddingSymbol extends BrickSnake2000Symbol
{

    constructor(args:SymbolArgs) {
        // Randomize symbol name
        const possibleSymbols = ["L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4"];
        const randomIndex = Math.floor(Math.random() * possibleSymbols.length);

        // Create symbol from randomized named
        args.symbolName = possibleSymbols[randomIndex];
        super(args);

        //Hide padding symbol
        this.visible = false;
    }
}